/** @module SiteAdmin/_New3DMixin **/
define([
	"dojo/_base/declare",
	"underscore",
	"csi/comm/Aspera",
	"csi/comm/PostRequest",
	"csi/html",
	"csi/locale",
	"csi/sessionConstants",
	"csi/util",
	"csi/table/New",
	"csi/xml"
], function (declare, _, Aspera, PostRequest, html, locale, sessionConstants, util, New, xml) {

	return declare(New, {
		/**
		 * @property {string} threeDOperation - operation for creating new 3d files
		 */
		threeDOperation: null,

		/**
		 * @override
		 * Disables Save and New Button
		 */
		_canRepeat: function () {
			return false;
		},

		/**
		 * @override
		 * Disables Save and go button
		 */
		_canNavigate: function () {
			return false;
		},

		/**
		 * Tests whether an extension is a Clo hardware file extension
		 * @param {string} extension
		 * @return {boolean}
		 */
		isCloType: function (extension) {
			let extensions = ["zfab", "trm", "btn", "bth", "zpac", "sst", "zsp", "zpl", "zsd"];
			return _.contains(extensions, extension);
		},

		/**
		 * @override
		 * Publish request to create new document
		 * Process Aspera Upload
		 */
		process: function () {
			// Use aspera for upload if enabled and allowed on the widget
			const self = this;
			const fd = this.getFormData();
			const docName = fd.getFieldValue(xml.ATTR_NAME);
			if (Aspera.isEnabled()) {
				this.disableActionView(true);
				this.closeDialog();
				var bMaterial = this.threeDOperation == "Create3DMaterial";
				var bPropagate = bMaterial ? fd.getFieldValue("3DPropagateToExistingColorMaterials") : false;
				Aspera.upload3DFile(this.widget.urlRoot, docName, this.popupView.asperaData, this, bMaterial, bPropagate).then(
					function (response) {
						self._onPublishResponse(response);
					},
					function (msg) {
						self.m_error = msg;
						self.postProcess(false);
					}
				);
				return;
			}
			const req = new PostRequest("SiteAdmin", this.threeDOperation);
			req.addParameter("Name", docName);
			req.addParameter("ParentURL", this.m_urlParent);
			req.addParameter("SessionURL", sessionConstants.sessionUrl);
			req.addFiles(fd.getFieldValueAsFile("SourceFile"), "SourceFile");
			req.addParameter("DefaultImage", fd.getFieldValue("DefaultImage"));
			req.addParameter("Propagate3DMaterials", fd.getFieldValue("3DPropagateToExistingColorMaterials"));

			if (this.isCloType(util.getFileExtension(fd.getFieldValue("SourceFile")))) {
				var item = fd.getField("DefaultImage").m_control.item;

				if (item && item.rawSrc) {
					req.addParameter("DefaultImageFile", html.b64toBlob(item.rawSrc, "image/" + item.ext));
				}
			}

			this.waitForPublish(req.post(), true);
		},

		/**
		 * @override
		 * Enable Action View in case of server side validation error
		 */
		postProcess: function () {
			this.inherited(arguments);
			if (Aspera.isEnabled() || Aspera.isValid()) {
				this.disableActionView(false);
			}
		},

		/**
		 * @override
		 * Track URL of new document
		 */
		onPublishResponse: function (response) {
			this.m_urlNode = response.getResultNode().$URL;
		}
	});
});
